<template>
    <div>
        <modal
               @closed="close"
               :cancel-button-text="$t('MODAL_UNDERSTOOD')"
               class="text-center">
            <p v-text="feedbackCopy" class="text-style"></p>
            <p>{{ $t('LEGAL_CANCEL_US_CASE_CONFIRMATION') }}</p>
        </modal>

    </div>
</template>

<script>
import Modal from '@/components/structure/Modal';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';

export default {
    name: 'CancelSubscriptionModal',
    data() {
        return {
            hasCancelled: false,
        };
    },
    props: {
        subscriptionId: {
            requires: true,
            type: Number,
        },
        isCutOffTimePassed: {
            type: Boolean,
            default: false,
        },
        nextDeliveryDate: {
            type: String,
        },
        error: {
            default: null,
        },
    },
    methods: {
        cancelSubscription() {
            let subscriptionService = new SubscriptionService();
            subscriptionService.cancelSubscription(this.subscriptionId)
                .then(() => {
                    this.hasCancelled = true;
                    this.$emit('cancelled', this.subscriptionId);
                })
                .catch(error => {
                    this.error = error || this.$t('CANCEL_SUB_MODAL');
                });
        },

        close() {
            if (this.hasCancelled === true) this.$store.dispatch('subscription/fetchAllSubscriptions', true);

            this.$emit('closed');
            this.$emit('paused');
        },

        getAddressLine(addressId) {
            return this.$store.getters['address/getAddressById'](addressId).address1;
        },
    },
    computed: {
        activeSubscriptions() {
            return this.$store.getters['subscription/getActiveSubscriptions'];
        },

        activeSubscriptionsAfterCancel() {
            return this.activeSubscriptions
                .filter(subscription => subscription.id !== this.subscriptionId);
        },

        address() {
            return this.$store.getters['address/getAddressById'](this.subscription.delivery_address_id);
        },
        subscription() {
            return this.$store.getters['subscription/getSubscriptionById'](this.subscriptionId);
        },

        feedbackCopy() {
            if (this.error) return this.$t('LEGAL_CANCEL_US_CASE_3');
            if (this.isCutOffTimePassed && this.nextDeliveryDate) return this.$t('LEGAL_CANCEL_US_CASE_2', { mustReceiveDeliveryDate: this.nextDeliveryDate });
            return this.$t('LEGAL_CANCEL_US_CASE_1', { username: this.address.first_name });
        },
    },
    components: {
        Modal,
    },
};
</script>
<style scoped>
    .text-style{
        font-weight: bold;
    }
</style>
